export class RegionalModel {
  id: number;
  name: string;
  email: string;
  roles: string[];
  phone?: string;
  isActive: boolean;
  createdAt?: Date;
  updatedAt?: Date;

  // Roles específicos para regional
  static ROLES = {
    ROLE_REGIONAL: { CODE: 'ROLE_REGIONAL', DESC: 'Regional' },
  };
}
